import { matchPath, useLocation } from 'react-router-dom';

export type IUseActiveLinkProps = {
  matchPatterns?: Array<string>;
  href?: string;
  exact?: boolean;
};

export type IUseActiveLinkResult = boolean;

export const useActiveLink = (
  props: IUseActiveLinkProps,
): IUseActiveLinkResult => {
  const { matchPatterns, href, exact } = props;
  const location = useLocation();
  const isActive = matchPatterns
    ? matchPatterns.some((pattern) => matchPath(pattern, location.pathname))
    : href
      ? matchPath(exact ? href : `${href}/*`, location.pathname)
      : false;

  return !!isActive;
};
